export class NoteConceptDetailResponse {
  noteConceptId: number = 0;
  noteId: number = 0;
  conceptInvoicingId: number = 0;
  storeId: number = 0;
  invoicedValue: number = 0;
  invoiceResidue: number = 0;
  value: number = 0;
}